export type CashReportConfig = {
  cashReportEnabled?: boolean
}

export function isCashReportEnabled(
  config: CashReportConfig | null | undefined,
): boolean {
  return config?.cashReportEnabled === true
}
